module.exports = "//a.spikex.com/sigma/frontend-ssr-web-user-center/_next/static/images/sao-dark-2469feb80aa386e535de7254324b9e97.svg";